import request from '../config/request'

// const prefix = '/cms'

// export const FetchCmsAPI = async (params: any) => {
//   const responseType = params.format ? 'blob' : undefined
//   const response = await request({
//     url: prefix + '/document/list',
//     method: 'GET',
//     params,
//     responseType,
//   })

//   return response
// }

// export const AddCmsAPI = async (body: any) => {
//   const response = await request({
//     url: prefix + '/create-page',
//     method: 'POST',
//     body,
//   })

//   return response
// }

// export const GetCmsProfileAPI = async (params: any) => {
//   const response = await request({
//     url: `${prefix}/document/${params.CmsId}`,
//   })

//   return response
// }

// export const UpdateCmsProfileAPI = async (body: any) => {
//   const response = await request({
//     url: prefix + `/update/document/${body.CmsId}?name=${body.name}&for=${body.for}`,
//     method: 'PUT',
//     body,
//   })

//   return response
// }

// export const DeleteCmsApi = async (body: any) => {
//   const response = await request({
//     method: 'DELETE',
//     url: `${prefix}/delete/document/${body.CmsId}`,
//     body,
//   })

//   return response
// }

// cms api for the about-us, policy-policy and terms and condition

export const fetchAboutUsCMSAPI = async (lan: any) => {
  const response = await request({
    url: `/app/about-us?pageFor=provider&language=${'en'}`,
    method: 'GET',
  })

  return response
}

export const fetchPrivacyPolicyCMSAPI = async (lan: any) => {
  console.log(lan, 'lan hello')
  const response = await request({
    url: `/app/privacy-and-policy?pageFor=provider&language=${'en'}`,
    method: 'GET',
  })

  return response
}

export const fetchTermAndConditionCMSAPI = async (lan: any) => {
  const response = await request({
    url: `/app/terms-and-conditions?pageFor=provider&language=${'en'}`,
    method: 'GET',
  })

  return response
}
